import React, { useState, useEffect, useCallback, Fragment } from "react";
import { useSelector } from "react-redux";
import { Route, Routes } from "react-router";
import moment from "moment-timezone";
import Layout from "../Layout";
import Spinner from "../Layout/Spinner";
import Overview from "../Overview";
import Picks from "../Picks";
import Games from "../Games";
import Leaderboard from "../Leaderboard";import LeaderboardExplorer from "../LeaderboardExplorer";
import Rules from "../Rules";
import Results from "../Results";
import AppRedirect from "./AppRedirect";
import SigninRedirect from "./SigninRedirect";

const Router = (props) => {
  const { userStatus, contestStatus } = props;
  const userId = useSelector((state) => state.app?.userId);
  const loading = useSelector((state) => state.app?.loading);
  const picksLoading = useSelector((state) => state.picks?.loading);
  const gamesLoading = useSelector((state) => state.games?.loading);

  const [pageFocus, setPageFocus] = useState(userStatus?.pageFocus || "");

  const isAuthed = useCallback(() => {
    return !!userId;
  }, [userId]);

  useEffect(() => {
    !!userStatus && setPageFocus(userStatus.pageFocus);
  }, [userStatus]);

  const getEntryPage = () => {
    switch (userStatus?.entryPage) {
      case "overview":
        return <Overview />;
      case "group":
        return <Picks tab="group" focus={pageFocus} />;
      case "knockout":
        return <Picks tab="knockout" focus={pageFocus} />;
      case "results": {
        const currTime = moment().unix();
        const firstKoTimestampUnix = 1782705600;

        return (
          <Results
            tab={currTime < firstKoTimestampUnix ? "group" : "knockout"}
          />
        );
      }
      default:
        return <Overview />;
    }
  };

  const authenticatedRoutes = (
    <>
      {/* entry pages */}
      <Route exact path="/" element={getEntryPage()} />
      <Route exact path="/overview" element={<Overview />} />
      <Route
        exact
        path="/picks/group"
        element={<Picks tab="group" focus={pageFocus} />}
      />
      <Route
        exact
        path="/picks/knockout"
        element={<Picks tab="knockout" focus={pageFocus} />}
      />

      <Route exact path="/results/group" element={<Results tab="group" />} />
      <Route
        exact
        path="/results/knockout"
        element={<Results tab="knockout" />}
      />

      <Route exact path="/games" element={<Games />} />
      <Route exact path="/rules" element={<Rules />} />
      <Route exact path="/leaderboard" element={<Leaderboard />} />      <Route exact path="/leaderboard/explorer" element={<LeaderboardExplorer />} />
    </>
  );

  return (
    <>
      <Spinner
        show={loading || picksLoading || gamesLoading}
        fullscreen={true}
      />
      {isAuthed() ? (
        <Routes>
          <Route path="/get-app-redirect" element={<AppRedirect />} />
          <Route
            element={
              <Layout userStatus={userStatus} contestStatus={contestStatus} />
            }
          >
            {authenticatedRoutes}
          </Route>
        </Routes>
      ) : (
        <SigninRedirect />
      )}
    </>
  );
};

export default Router;
